/*
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-10 19:22:22
 * @LastEditors: lwq
 * @LastEditTime: 2020-08-11 10:21:06
 * @FilePath: \mrc-base-server-view\src\service\api\dataStoredProcedure.js
 */
// 存储空间管理接口
import http from '../httpConfig'
const table = 'mrbase_sys_datamodel_procedure'


// 运行储存过程语句
export const runSql = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/procedure/runSql/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 新增和修改储存过程
export const addUpdateProcedure = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/procedure/saveProcedure/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


// 删除储存过程
export const delProcedure = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/procedure/delProcedure/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 获取储存过程信息
export const getProcedureInfo = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/procedure/getProcedureInfo/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 获取所有储存过程信息
export const getProcedureAll = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/procedure/getProcedureAll/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}